import type { ReactNode } from 'react';
import { LotusDivider } from './lotus';

export function SectionHeading({
  id,
  children,
  tone = 'dark',
  aside,
}: {
  id?: string;
  children: ReactNode;
  tone?: 'dark' | 'light';
  aside?: ReactNode;
}) {
  return (
    <div data-reveal className="flex flex-col items-center text-center">
      <h2
        id={id}
        className={`font-display text-[1.6rem] leading-tight font-medium tracking-[0.18em] uppercase sm:text-[2.1rem] ${
          tone === 'dark' ? 'text-maroon' : 'text-champagne'
        }`}
      >
        {children}
      </h2>
      <LotusDivider className="mt-4" />
      {aside && <div className="mt-4">{aside}</div>}
    </div>
  );
}
